import { HeroAiPoweredData } from './type'

export const heroAiPoweredData: HeroAiPoweredData = {
  eyebrow: 'Personalised by Pixie',
  headline: 'Personalised storybooks',
  headlineAccent: 'starring your child',
  subtitle: 'Upload a photo, pick a story, and we illustrate every page with your child as the hero. Hand-crafted style, printed, bound, and shipped to your door.',
  primaryCtaText: 'Browse Stories',
  primaryCtaLink: '/shop',
  transformations: [
    {
      id: 'east-asian-mermaid',
      beforeImageUrl: '/images/hero-ai/photo-east-asian.png',
      beforeAlt: 'A child\'s photo before personalisation',
      afterImageUrl: '/images/hero-ai/storybook-east-asian-mermaid.png',
      afterAlt: 'The same child reimagined as a mermaid storybook hero',
      caption: 'From photo to storybook hero',
    },
    {
      id: 'caucasian-dragon',
      beforeImageUrl: '/images/hero-ai/photo-caucasian.png',
      beforeAlt: 'A child\'s photo before personalisation',
      afterImageUrl: '/images/hero-ai/storybook-caucasian-dragon.png',
      afterAlt: 'The same child reimagined as a dragon rescue hero',
      caption: 'Every child, their own adventure',
    },
    {
      id: 'african-space',
      beforeImageUrl: '/images/hero-ai/photo-african.png',
      beforeAlt: 'A child\'s photo before personalisation',
      afterImageUrl: '/images/hero-ai/storybook-african-space.png',
      afterAlt: 'The same child reimagined as a space explorer',
      caption: 'Brave adventures, made just for them',
    },
    {
      id: 'hispanic-pirate',
      beforeImageUrl: '/images/hero-ai/photo-hispanic.png',
      beforeAlt: 'A child\'s photo before personalisation',
      afterImageUrl: '/images/hero-ai/storybook-hispanic-pirate.png',
      afterAlt: 'The same child reimagined as a pirate treasure hunter',
      caption: 'A hero who looks like your child',
    },
    {
      id: 'south-asian-forest',
      beforeImageUrl: '/images/hero-ai/photo-south-asian.png',
      beforeAlt: 'A child\'s photo before personalisation',
      afterImageUrl: '/images/hero-ai/storybook-south-asian-forest.png',
      afterAlt: 'The same child reimagined in an enchanted forest',
      caption: 'Magical worlds where they belong',
    },
  ],
}
